import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';

/**
 * Note: The containing element must be position: relative for this to work properly
 */
const PlayIcon = ({ size, onClick }) => (
    <div className="playIconContainer" style={{ fontSize: size }}>
        <div className="playIconShadow" />
        <div
            className="playIcon"
            role="button"
            tabIndex={0}
            aria-label="Start video"
            onClick={onClick}
            onKeyUp={onClick}
        />
    </div>
);

PlayIcon.propTypes = exact({
    size: PropTypes.number, // default 7 (font-size)
    onClick: PropTypes.func,
});

export default PlayIcon;
